import { TwoStepAuthentication } from '@/src/modules/AuthModule/components/TwoStepAuthentication';

type Props = {};

const MultiFactorAuthentication = (props: Props) => {
  return (
    <div className="flex h-full w-full justify-center">
      <TwoStepAuthentication />
    </div>
  );
};

export default MultiFactorAuthentication;
